import React from 'react';
import { Link } from 'react-router-dom';
import { BookOpen, Shield, Layers, Video } from 'lucide-react';

const GiftsPage = () => {
  const gifts = [
    {
      title: "Free Business Assessment Quiz",
      description: "Discover the hidden gaps holding your coaching business back with our 5-minute assessment.",
      icon: <Shield className="w-8 h-8 text-green-400" />,
      path: "/gifts/free-quiz",
      color: "from-green-50 to-green-100"
    },
    {
      title: "AI Revolution Ebook",
      description: "Learn how smart coaches are booking 2x more clients with half the effort using AI.",
      icon: <BookOpen className="w-8 h-8 text-green-400" />,
      path: "/gifts/ebook",
      color: "from-green-50 to-green-100"
    },
    {
      title: "Proven Funnel Template",
      description: "Copy & paste this battle-tested funnel that's generating $10K+ monthly for wellness coaches.",
      icon: <Layers className="w-8 h-8 text-green-400" />,
      path: "/gifts/funnel-template",
      color: "from-green-50 to-green-100"
    },
    {
      title: "Free Scaling Webinar",
      description: "Learn how to double your revenue without burnout in our exclusive webinar.",
      icon: <Video className="w-8 h-8 text-green-400" />,
      path: "/gifts/webinar",
      color: "from-green-50 to-green-100"
    }
  ];

  return (
    <section className="py-16 md:py-20 bg-white">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h1 className="text-3xl md:text-5xl font-extrabold text-green-800 mb-4">Free Resources for Wellness Coaches</h1>
          <p className="text-lg md:text-xl text-green-600">Choose from our collection of proven tools and resources to help grow your coaching business.</p>
        </div>
        
        <div className="grid gap-6 md:grid-cols-2">
          {gifts.map((gift, index) => (
            <Link 
              key={index} 
              to={gift.path}
              className="block transform transition-all duration-300 hover:scale-105"
            >
              <div className={`bg-gradient-to-br ${gift.color} rounded-xl shadow-lg p-6 h-full border border-green-100`}>
                <div className="flex items-start gap-4">
                  <div className="flex-shrink-0">
                    {gift.icon}
                  </div>
                  <div>
                    <h3 className="text-xl font-bold text-green-800 mb-2">{gift.title}</h3>
                    <p className="text-green-700">{gift.description}</p>
                  </div>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default GiftsPage; 